module.exports = __webpack_public_path__ + "img/vaga3.ba2056f4.jpg";